import type { MessageEvent } from "@veto/domain";

export function groupMessagesByDay(
  items: MessageEvent[],
): { day: string; items: MessageEvent[] }[] {
  const groups: { day: string; items: MessageEvent[] }[] = [];
  for (const m of items) {
    const day = new Date(m.createdAt).toLocaleDateString(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
    const last = groups[groups.length - 1];
    if (!last || last.day !== day) groups.push({ day, items: [m] });
    else last.items.push(m);
  }
  return groups;
}
